var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDommicro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 249.5 131.9",
    style: {
      enableBackground: "new 0 0 249.5 131.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:#819EF0;enable-background:new    ;}\n\t.st1{opacity:0.4;fill:#819EF0;enable-background:new    ;}\n\t.st2{opacity:0.6;fill:#4A73E8;enable-background:new    ;}\n\t.st3{opacity:0.8;fill:#3F63C8;enable-background:new    ;}\n\t.st4{fill:#284389;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    className: "st0",
    width: 21.4,
    height: 21.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.2,
    y: 1.5,
    className: "st1",
    width: 21.4,
    height: 21.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 1.5,
    className: "st2",
    width: 21.4,
    height: 21.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 109.7,
    y: 1.5,
    className: "st3",
    width: 21.4,
    height: 21.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38.2,
    y: 37.3,
    className: "st1",
    width: 21.4,
    height: 21.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 37.3,
    className: "st2",
    width: 21.4,
    height: 21.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 109.7,
    y: 37.3,
    className: "st3",
    width: 21.4,
    height: 21.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 145.4,
    y: 1.5,
    className: "st4",
    width: 21.4,
    height: 21.4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 145.4,
    y: 37.3,
    className: "st4",
    width: 21.4,
    height: 21.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 73,
    className: "st2",
    width: 21.4,
    height: 21.4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 109.7,
    y: 73,
    className: "st3",
    width: 21.4,
    height: 21.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 109.7,
    y: 108.7,
    className: "st3",
    width: 21.4,
    height: 21.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M183.2,1.5V23c23.7,0,42.9,19.2,42.9,42.9s-19.2,42.9-42.9,42.9h-16.3V73h-21.4v57.2h0.8h20.6h16.3 c35.5,0,64.3-28.8,64.3-64.3S218.7,1.5,183.2,1.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDommicro);
export default __webpack_public_path__ + "static/media/DOMMICRO.6007068e8ba76221e56e7b0bd9150f95.svg";
export { ForwardRef as ReactComponent };